export default __webpack_public_path__ + "b9b91bd25b812e1b2d7432f897fd757a.png";